<template lang="pug">
  v-app-bar(
    app
    color="grey lighten-5"
    clipped-right
    flat
  )
    v-app-bar-nav-icon(@click.stop="toggleDrawer()")
      v-icon(
        class="mx-4"
        large
      ) mdi-menu

    v-toolbar-title.grey--text
      portal-target(name="pageTitle")

    v-spacer

    portal-target(name="contols")

    v-btn.ml-7.mr-4( icon @click.stop="logout()")
      v-icon mdi-logout-variant

</template>

<script>
import { onLogout, getRefreshToken, refreshToken, getToken } from '@/vue-apollo'
import RefreshTokenGQL from '@/graphql/switips/RefreshToken.graphql'

let localTimer

export default {
  props: {
    drawerState: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    toggleDrawer() {
      this.$emit('toggleDrawer', !this.drawerState)
    },
    async checkToken() {
      if (getRefreshToken() === null) {
        return
      }
      try {
        const result = await this.$apollo.mutate({
          client: 'auth',
          mutation: RefreshTokenGQL,
          variables: {
            input: {
              refresh_token: getRefreshToken()
            }
          }
        })

        if (!result || !result.data || (result.errors && result.errors.length > 0)) {
          await onLogout(this.$apollo.getClient())

          this.errorNotify({
            message: this.accessDeniedMsg,
            delay: 1000,
            timeout: 5000
          })
          if (!this.skipLogin()) {
            await this.$router.push('/login').catch()
          }
        } else {
          refreshToken(result.data.refresh.access_token, result.data.refresh.refresh_token)
          return
        }
      } catch (err) {
        console.log(err)

        await onLogout(this.$apollo.getClient())

        this.errorNotify({
          message: this.accessDeniedMsg,
          delay: 1000,
          timeout: 5000
        })
      }
      if (!this.skipLogin()) {
        await this.$router.push('/login').catch()
      }
    },
    async checkTokenAndLogout() {
      if (getToken() === null) {
        await onLogout(this.$apollo.getClient())
        if (!this.skipLogin()) {
          await this.$router.push('/login').catch()
        }
        return
      }

      setTimeout(async () => {
        await this.checkTokenAndLogout()
      }, 1000 * 1)
    },
    async logout() {
      await onLogout(this.$apollo.getClient())
      await this.$router.push({
        name: 'login'
      })
    }
  },
  beforeMount() {
    setInterval(() => {
      this.shouldUpdateIframeLogin = !this.shouldUpdateIframeLogin
    }, 60 * 1000)

    setTimeout(async () => {
      await this.checkTokenAndLogout()
    }, 1000 * 1)
  },

  mounted() {
    localTimer = setInterval(() => {
      this.checkToken()
    }, 1000 * 10 * (+process.env.VUE_APP_REFRESH_TOKEN_INTERVAL))
  },

  beforeDestroy() {
    clearInterval(localTimer)
  }
}
</script>
